export const ugPdfs = {
  "State Board": {},
};

